import { useContext } from 'react';
import AuthContext from 'src/contexts/FirebaseAuthContext';
// import AuthContext from 'src/contexts/Auth0Context';
// import AuthContext from 'src/contexts/JWTAuthContext';
const useAuth = () => useContext(AuthContext);

export default useAuth;
